import * as designTokens from './spacing';

export const spacing = {
  ...designTokens,
};
